import React from 'react';

const DRIVE_FOLDER_LINK = "https://drive.google.com/embeddedfolderview?id=1PnuXStcoFdPV-BNPM7l1XkMMgvJyVA-t#grid";
const EXTERNAL_DRIVE_LINK = "https://drive.google.com/drive/folders/1PnuXStcoFdPV-BNPM7l1XkMMgvJyVA-t?usp=sharing";

export const QuestionPapersTab = () => {
  return (
    <section id="question-papers" className="section-content">
      {/* Section Header */}
      <div className="mb-6">
        <h2 className="text-3xl font-bold text-gray-800" id="qp-dynamic-title">
          Question Papers Repository
        </h2>
        <p className="text-sm text-gray-600 mt-1" id="qp-dynamic-subtitle">
          Browse and view assessment papers for all grades
        </p>
      </div>

      {/* Main Container */}
      <div className="bg-white p-6 rounded-2xl shadow-lg border-2 border-gray-100 flex flex-col h-[85vh] select-none">
        <div className="flex items-center justify-between mb-4 p-4 bg-blue-50 rounded-xl border border-blue-100 flex-wrap gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center text-white text-2xl shadow-md">
              📂
            </div>
            <div>
              <h3 className="font-bold text-blue-900 text-lg">Digital Paper Archive</h3>
              <p className="text-xs text-blue-700 font-medium">Files are displayed in Grid View below.</p>
            </div>
          </div>
          <a
            href={EXTERNAL_DRIVE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-bold transition-colors shadow-sm hover:shadow-md cursor-pointer"
          >
            <span>Open Google Drive</span> <span className="text-xl">↗</span>
          </a>
        </div>

        <div className="flex-1 bg-gray-100 rounded-xl border-2 border-gray-200 overflow-hidden relative">
          <iframe
            id="folder-frame"
            className="w-full h-full bg-white"
            src={DRIVE_FOLDER_LINK}
            title="Question Papers Folder"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};
export default QuestionPapersTab;
